import Vue from 'vue'

import './styles/quasar.sass'
import '@quasar/extras/material-icons/material-icons.css'
import {Quasar, Notify, QSpinner} from 'quasar'

Vue.use(Quasar, {
  config: {},
  components: {QSpinner},
  directives: { /* not needed if importStrategy is not 'manual' */},
  plugins: {
    Notify,

  }
})


Notify.setDefaults({
  position: 'top-right',
  timeout: 5500,
  color: 'theme-color',
  textColor: 'theme-color',
  actions: [{icon: 'close', color: 'black'}]
})